import { lazy } from 'react';
import Logistic from './Logistic';
import InvoiceEditor from './InvoiceEditor';
import LogistcsSettings from './LogistcSettings';
import HsCode from './HsCode';

const LogisticConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/logistics',
            element: <Logistic />,
        },
        {
            path: '/logistics-invoice/:containerId',
            element: <InvoiceEditor />,
        },
        {
            path: '/logistics/settings',
            element: <LogistcsSettings />,
        },
        {
            path: '/logistics/hscode',
            element: <HsCode />,
        },
    ],
};

export default LogisticConfig;
